/**
 * Единственная точка переключения меню и главной (agroai-0yt.13).
 *
 * `v2` (по умолчанию) — новое меню и «Обзор района» на `/`.
 * `v1` — прежнее меню и прежняя главная («Картина сезона», DecisionCenter).
 * Откат — переменная окружения `VITE_NAV=v1` и пересборка, без правки кода.
 */
export type NavVersion = 'v1' | 'v2';

export function parseNavVersion(raw: string | undefined): NavVersion {
  return raw === 'v1' ? 'v1' : 'v2';
}

export const NAV_VERSION: NavVersion = parseNavVersion(
  import.meta.env.VITE_NAV as string | undefined,
);
